export const columns = [
  {
    title: 'URL',
    key: 'url',
    headerClassName: 'column-url',
  }
];